import script from "./AccountConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountConfig.vue?vue&type=script&setup=true&lang=js"

import "./AccountConfig.vue?vue&type=style&index=0&id=61b6e13d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61b6e13d"]])

export default __exports__